import { render, staticRenderFns } from "./ModalAdminCreate.vue?vue&type=template&id=45b0fdce&scoped=true"
import script from "./ModalAdminCreate.vue?vue&type=script&lang=js"
export * from "./ModalAdminCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0fdce",
  null
  
)

export default component.exports